import React from 'react'

import './Dashboard.css'

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <div id="dashboard"></div>
    </div>
  )
}

export default Dashboard
